// New PaySimple reconciliation page — renders the shared ReconWorkspace with the PaySimple config.
// Parallel to the existing PaysimpleReconciliationPage (untouched) until cutover.
import React from 'react';
import ReconWorkspace from '../../components/recon/ReconWorkspace';
import paysimpleConfig from '../../config/recon/paysimple';

export default function PaysimpleReconciliationNewPage() {
  return <ReconWorkspace config={paysimpleConfig} />;
}
